module.exports = __webpack_public_path__ + "img/emoby.032f7439.png";